/**
 * KnowledgeBaseQAService
 *
 * Calls the AI Management knowledge-search endpoint. Anonymous-capable — the
 * backend filters by visibility based on caller auth, and applies a per-caller
 * token-bucket rate limiter. Pass <c>anonymousId</c> from
 * <c>localStorage['ccms_anon_id']</c> so anon callers get their own bucket.
 *
 * Route: POST /api/ai/knowledge/search
 */
import { BaseService } from '../base/BaseService';
export class KnowledgeBaseQAService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? KnowledgeBaseQAService.DEFAULT_SERVICE_PATH,
            basePath: KnowledgeBaseQAService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async search(request) {
        const response = await this.searchRaw(request);
        return response.data ?? null;
    }
    searchRaw(request) {
        return this.http.post(this.buildUrl('search'), request);
    }
    /**
     * Multi-turn chat. The backend takes the whole conversation transcript +
     * the top retrieved documents and either answers with citations or asks a
     * clarifying question. Keep the transcript trimmed to the most recent N
     * turns client-side to control token cost.
     */
    async chat(request) {
        const response = await this.chatRaw(request);
        return response.data ?? null;
    }
    chatRaw(request) {
        return this.http.post(this.buildUrl('chat'), request);
    }
    /**
     * Effective on/off state of the AI search/chat features (anonymous-capable).
     * The public Resource Centre uses this to show/hide the Ask AI / Chat tabs.
     */
    async getAvailability() {
        const response = await this.getAvailabilityRaw();
        return response.data ?? null;
    }
    getAvailabilityRaw() {
        return this.http.get(this.buildUrl('availability'));
    }
}
/** AIManagement micro-service routes by default under "ai-management". */
KnowledgeBaseQAService.DEFAULT_SERVICE_PATH = 'ai-management';
KnowledgeBaseQAService.BASE_PATH = 'api/ai/knowledge';
//# sourceMappingURL=KnowledgeBaseQAService.js.map